<div class="dialog-wrapper">
  <div class="dialog-header">
    <h2 class="truncate flex items-center space-x-2">
      <fa-icon class="text-green" [icon]="['fal', 'badge-check']"></fa-icon>
      <span>{{ 'GENERAL.DIALOGS.SUCCESS_DIALOG.SUCCESS' | transloco }}</span>
    </h2>
    <button mat-icon-button mat-dialog-close>
      <fa-icon class="font-bold" size="2x" [icon]="['fal', 'xmark']"></fa-icon>
    </button>
  </div>
  <mat-dialog-content class="mat-typography">
    <div class="wrapper full p-4 border-radius-8">
      <span>{{ data }}</span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="p-32 mt-auto">
    <button mat-button mat-dialog-close cdkFocusInitial>{{ 'GENERAL.BUTTONS.CLOSE' | transloco }}</button>
  </mat-dialog-actions>
</div>
